

import React from 'react'
import {Modal,ButtonToolbar,Button} from 'react-bootstrap'

class JSWorkDocViewModal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {show:false,wo:""}
  }

  componentDidMount(){
   
  }

  componentWillMount(){
//    // if(window.show_work_doc_alone!==undefined){
//         setTimeout(()=>{
//             window.show_work_doc_alone(this.props.wo);
//         },1000)            
//    // }
}

  loadData(wo){
    
    this.setState({show:true,wo:wo},()=>{
        if(typeof window.show_work_doc_alone !=="undefined"){
            window.onWorkClickBack = ()=>{
                this.onHide()
                window.onWorkClickBack = undefined
            }
            window.show_work_doc_alone(wo,"row-work-doc-modal")    
        }
    })      
  }

  onClick(){
    if(typeof window.show_work_doc_alone !=="undefined")    
        window.show_work_doc_alone(this.props.wo,"row-work-doc-modal")
  }

  onHide(){
      this.setState({show:false})
  }

  renderContent(){
    let h = window.innerHeight-60;
    let height = h+"px";
    
    return (
    <div style={{height:height,overflow:"auto"}}>
        <section className="content-header" style={{display:"none"}}>
            <h1>ใบงานเลขที่ 
                <span id="span-work-no" style={{fontWeight:"bold",display:"inline"}}>{this.state.wo}</span>
                <input type="text" value={this.state.wo} id="input-work-no" style={{display:"none"}}/>
            </h1>
            <ol className="breadcrumb"></ol>
        </section>
        <div id="row-work-doc-modal">
            <div onClick={this.onClick.bind(this)}>Loading... </div>
        </div>
      </div>
    )      
  }

  render(){

      return (
          <Modal className={"js-workdoc"}  show={this.state.show} onHide={this.onHide.bind(this)} enforceFocus={true} bsSize={'lg'} dialogClassName="fullwidth-dialog">
            <Modal.Header closeButton className="hide3">
                <Modal.Title>ใบงานเลขที่ {this.state.wo}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="modal-body-print-report">
                {this.state.show && this.renderContent()}            
            </Modal.Body>            
        </Modal>               
      )
  }
}

JSWorkDocViewModal.defaultProps = {
    title:""
}

export default JSWorkDocViewModal;



// WEBPACK FOOTER //
// ./src/view/workdoc/JSWorkdocViewModal.js